(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scrolling-logo-cloud"] && !Shopify.designMode) return;
  try {
    
  // Additional JavaScript for better performance
  document.addEventListener('DOMContentLoaded', function() {
    // Check if there are any logos in the section
    const tracks = document.querySelectorAll('.track-horizontal-template--28482392228134__ss_scrolling_logo_cloud_DEdVUa');
    if (tracks.length > 0) {
      // Make sure the animation is smooth
      tracks.forEach(track => {
        track.style.willChange = 'transform';
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
